/*
  New Custom Badge System - JavaScript Version
  Duplicates the functionality of snippets/new-custom-badge.liquid
  
  Usage:
    const badgeSystem = new NewCustomBadgeSystem();
    const badgeHTML = badgeSystem.renderCustomBadge(product, options);
*/

class NewCustomBadgeSystem {
  constructor() {
    this.settings = window.theme?.customBadge || {};
  }

  /*
    Get current market exactly like Liquid does (reusing from fake discount system)
  */
  getCurrentMarket() {
    // Try to get market from Shopify localization if available
    if (window.Shopify?.locale?.country) {
      const country = window.Shopify.locale.country.toLowerCase();
      // Map country codes to markets to match Liquid logic
      switch (country) {
        case 'us': return 'us';
        case 'ca': return 'ca';
        case 'au': return 'australia';
        case 'nz': return 'australia'; // New Zealand uses Australia settings
        case 'de': return 'germany';
        case 'gb': return 'uk';
        case 'fr':
        case 'es':
        case 'it':
        case 'nl':
        case 'be':
        case 'at':
        case 'se':
        case 'dk':
        case 'no':
        case 'fi':
        case 'pl':
        case 'pt':
        case 'ch':
          return 'europe';
        default:
          return 'international';
      }
    }
    
    // Fallback to Shopify.country if available
    if (window.Shopify?.country) {
      const country = window.Shopify.country.toLowerCase();
      switch (country) {
        case 'us':
        case 'united states':
          return 'us';
        case 'ca':
        case 'canada':
          return 'ca';
        case 'au':
        case 'australia':
          return 'australia';
        case 'nz':
        case 'new zealand':
          return 'australia';
        case 'de':
        case 'germany':
          return 'germany';
        case 'gb':
        case 'uk':
        case 'united kingdom':
          return 'uk';
        case 'fr':
        case 'es':
        case 'it':
        case 'nl':
        case 'be':
        case 'at':
        case 'se':
        case 'dk':
        case 'no':
        case 'fi':
        case 'pl':
        case 'pt':
        case 'ch':
          return 'europe';
        default:
          return 'international';
      }
    }
    
    // Default fallback
    return 'us';
  }

  /*
    Get market-specific custom badge settings
  */
  getMarketSettings(market) {
    const customBadge = this.settings;
    
    let settings = {};
    
    switch (market) {
      case 'us':
        settings = {
          enabled: customBadge.usEnabled || false,
          text: customBadge.usText || 'NEW',
          bgColor: customBadge.usBgColor || '#000000',
          textColor: customBadge.usTextColor || '#FFFFFF',
          fontSize: customBadge.usFontSize || 12,
          borderRadius: customBadge.usBorderRadius || 0,
          opacity: customBadge.usOpacity || 100,
          padding: customBadge.usPadding || 6,
          width: customBadge.usWidth || 80,
          height: customBadge.usHeight || 25
        };
        break;
      case 'ca':
        settings = {
          enabled: customBadge.canadaEnabled || false,
          text: customBadge.canadaText || 'NEW',
          bgColor: customBadge.canadaBgColor || '#000000',
          textColor: customBadge.canadaTextColor || '#FFFFFF',
          fontSize: customBadge.canadaFontSize || 12,
          borderRadius: customBadge.canadaBorderRadius || 0,
          opacity: customBadge.canadaOpacity || 100,
          padding: customBadge.canadaPadding || 6,
          width: customBadge.canadaWidth || 80,
          height: customBadge.canadaHeight || 25
        };
        break;
      case 'australia':
        settings = {
          enabled: customBadge.australiaEnabled || false,
          text: customBadge.australiaText || 'NEW',
          bgColor: customBadge.australiaBgColor || '#000000',
          textColor: customBadge.australiaTextColor || '#FFFFFF',
          fontSize: customBadge.australiaFontSize || 12,
          borderRadius: customBadge.australiaBorderRadius || 0,
          opacity: customBadge.australiaOpacity || 100,
          padding: customBadge.australiaPadding || 6,
          width: customBadge.australiaWidth || 80,
          height: customBadge.australiaHeight || 25
        };
        break;
      case 'europe':
        settings = {
          enabled: customBadge.europeEnabled || false,
          text: customBadge.europeText || 'NEW',
          bgColor: customBadge.europeBgColor || '#000000',
          textColor: customBadge.europeTextColor || '#FFFFFF',
          fontSize: customBadge.europeFontSize || 12,
          borderRadius: customBadge.europeBorderRadius || 0,
          opacity: customBadge.europeOpacity || 100,
          padding: customBadge.europePadding || 6,
          width: customBadge.europeWidth || 80,
          height: customBadge.europeHeight || 25
        };
        break;
      case 'germany':
        settings = {
          enabled: customBadge.germanyEnabled || false,
          text: customBadge.germanyText || 'NEW',
          bgColor: customBadge.germanyBgColor || '#000000',
          textColor: customBadge.germanyTextColor || '#FFFFFF',
          fontSize: customBadge.germanyFontSize || 12,
          borderRadius: customBadge.germanyBorderRadius || 0,
          opacity: customBadge.germanyOpacity || 100,
          padding: customBadge.germanyPadding || 6,
          width: customBadge.germanyWidth || 80,
          height: customBadge.germanyHeight || 25
        };
        break;
      case 'uk':
        settings = {
          enabled: customBadge.ukEnabled || false,
          text: customBadge.ukText || 'NEW',
          bgColor: customBadge.ukBgColor || '#000000',
          textColor: customBadge.ukTextColor || '#FFFFFF',
          fontSize: customBadge.ukFontSize || 12,
          borderRadius: customBadge.ukBorderRadius || 0,
          opacity: customBadge.ukOpacity || 100,
          padding: customBadge.ukPadding || 6,
          width: customBadge.ukWidth || 80,
          height: customBadge.ukHeight || 25
        };
        break;
      case 'international':
        settings = {
          enabled: customBadge.internationalEnabled || false,
          text: customBadge.internationalText || 'NEW',
          bgColor: customBadge.internationalBgColor || '#000000',
          textColor: customBadge.internationalTextColor || '#FFFFFF',
          fontSize: customBadge.internationalFontSize || 12,
          borderRadius: customBadge.internationalBorderRadius || 0,
          opacity: customBadge.internationalOpacity || 100,
          padding: customBadge.internationalPadding || 6,
          width: customBadge.internationalWidth || 80,
          height: customBadge.internationalHeight || 25
        };
        break;
      default:
        // Default/fallback settings
        settings = {
          enabled: customBadge.enabled || false,
          text: customBadge.text || 'NEW',
          bgColor: customBadge.bgColor || '#000000',
          textColor: customBadge.textColor || '#FFFFFF',
          fontSize: customBadge.fontSize || 12,
          borderRadius: customBadge.borderRadius || 0,
          opacity: customBadge.opacity || 100,
          padding: customBadge.padding || 6,
          width: customBadge.width || 80,
          height: customBadge.height || 25
        };
    }
    
    return settings;
  }

  /*
    Check if badge should be hidden based on conditions
  */
  shouldHideBadge(product, options = {}) {
    // Hide badge if in 'steals-deals' collection
    if (options.cardCollection?.handle === 'steals-deals' || 
        options.collection?.handle === 'steals-deals') {
      return true;
    }

    // Hide badge if product title contains specific words
    if (product.title) {
      const titleLower = product.title.toLowerCase();
      if (titleLower.includes('custom') ||
          titleLower.includes('personalized') ||
          titleLower.includes('measure') ||
          titleLower.includes('personnalisé')) {
        return true;
      }
    }

    return false;
  }

  /*
    Calculate custom badge exactly like Liquid does
  */
  calculateCustomBadge(product, options = {}) {
    const currentMarket = this.getCurrentMarket();
    const marketSettings = this.getMarketSettings(currentMarket);
    
    // Check if badge should be shown
    const shouldShow = marketSettings.enabled && !this.shouldHideBadge(product, options);
    
    if (!shouldShow) {
      return {
        shouldShow: false,
        badgeHTML: null,
        marketSettings: marketSettings
      };
    }

    // Calculate opacity as decimal
    const opacity = (marketSettings.opacity || 100) / 100.0;

    // Generate badge HTML
    const badgeHTML = `
      <div class="custom-badge-wrapper position-absolute" style="z-index: 2; top: 10px; left: 10px;">
        <span
          class="custom-badge badge"
          style="
            padding: ${marketSettings.padding}px;
            width: ${marketSettings.width}px;
            height: ${marketSettings.height}px;
            font-size: ${marketSettings.fontSize}px;
            background-color: ${marketSettings.bgColor} !important;
            color: ${marketSettings.textColor} !important;
            border-radius: ${marketSettings.borderRadius}px !important;
            opacity: ${opacity};
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            text-transform: uppercase;
            line-height: 1.2;
          "
        >
          ${marketSettings.text}
        </span>
      </div>
    `;

    return {
      shouldShow: true,
      badgeHTML: badgeHTML,
      marketSettings: marketSettings
    };
  }

  /*
    Render custom badge (main public method)
  */
  renderCustomBadge(product, options = {}) {
    const badgeData = this.calculateCustomBadge(product, options);
    
    if (badgeData.shouldShow) {
      return badgeData.badgeHTML;
    }
    
    return '';
  }

  /*
    Get CSS styles for custom badges (for responsive design)
  */
  getCustomBadgeCSS() {
    return `
      <style>
        .custom-badge-wrapper {
          z-index: 2;
          top: 10px;
          left: 10px;
        }

        .custom-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          text-transform: uppercase;
          line-height: 1.2;
        }

        @media screen and (max-width: 767px) {
          .custom-badge-wrapper {
            top: 5px;
            left: 5px;
          }
        }
      </style>
    `;
  }
}

// Export for use in other files
if (typeof window !== 'undefined') {
  window.NewCustomBadgeSystem = NewCustomBadgeSystem;
}